export default __webpack_public_path__ + "static/media/map-1-safari-14.50a77a27.jpg";